import {Component} from "@angular/core";

@Component({
  selector: 'cm-header',
  templateUrl: './header.component.html',
  host: {'class': 'header'}
})
export class HeaderComponent {

  constructor() {
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-formation/digicerba-catalogue-formation-web/src/angular/cerba/src/app/pages/cerba/header/header.component.ts